import Usa from "./usa"

export const flag = {
  US: Usa, // United States of America
}
